import styled from "styled-components";

export const SignOutPage = styled.div`
  &&& {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;

    form {
      display: flex;
      flex-direction: column;
    }

    input,
    button {
      width: 300px;
      margin-bottom: 15px;
      border: 1px solid rgba(34, 36, 38, 0.15);
      border-radius: 3px;
      padding: 10px 14px;
      line-height: 17px;
      font-size: 14px;
      outline: none;

      &:focus {
        border-color: #85b7d9;
        box-shadow: none;
      }
    }

    .forgot-password {
      color: ${props => props.theme.primary};
      font-size: 14px;

      &:hover,
      &:focus {
        color: ${props => props.theme.primaryLight};
      }
    }

    h1 {
      font-family: Roboto,"Helvetica Neue",Arial,Helvetica,sans-serif !important;
      font-size:18px;
      font-weight:bold;
      color: #04435E;
      width: 40%;
    }

    p.subtitle {
      font-family: Roboto,"Helvetica Neue",Arial,Helvetica,sans-serif !important;
      color: #424242;
      font-size:24px;      
      width: 40%;
    }

    p.more {
      font-family: Roboto,"Helvetica Neue",Arial,Helvetica,sans-serif !important;
      font-size: 16px;
      color: #9e9e9e;
      width: 40%;
    }

    button {
      background-color: ${props => props.theme.primary};
      color: ${props => props.theme.white};
      cursor: pointer;

      &:hover,
      &:focus {
        background-color: ${props => props.theme.primaryLight};
      }
    }
  }
`;

export const Logo = styled.div`
  &&& {
    margin-bottom: 40px;
    max-width: 300px;
    width: 100%;
    max-height: 120px;
  }

  img {
    width: 100%;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SignOut/style.js